import { ApplyForChangeToAdminMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const applyForChangeToAdminHandler =
  graphql.mutation<ApplyForChangeToAdminMutation>(
    "applyForChangeToAdmin",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          applyForChangeToAdmin: true,
        },
      });
    }
  );
